export default __webpack_public_path__ + "img/euVMoNkq.868ec5a3.svg";